import styled, {keyframes} from 'styled-components';

import Image from '../../common/Image/Image';
import SignUpLockIcon from '../../../../Icons/SignUpLockIcon';
import FreeBreakfast from '../../../../Icons/Amenities/FreeBreakfast';

export const OuterWrapperDiv = styled.div`
  cursor: pointer;
`;

export const ImageGalleryWrapperDiv = styled.div(
  props => `
  display: flex;
  flex-direction:column;
  justify-content: space-between;
  width: 29%;
  padding: ${props.theme.spacing.custom(12)};
  position: relative;
`,
);

/** This wrapper class is for meta landing */

export const WrapperSectionMetaDiv = styled.div`
  margin-bottom: ${props => props.theme.spacing.base};
  background-color: ${props => props.theme.colors.goWhite.base};
  display: flex;
  min-height: 29rem;
  position: relative;
  border: ${props =>
    props.displayBorder
      ? `0.2rem solid ${props.theme.colors.goBrandOrange.base}`
      : '.2rem solid transparent'};
  border-radius: ${props => props.theme.misc.borderRadius.xxxlarge};
  &:hover {
    border: 0.2rem solid ${props => props.theme.colors.goBrandBlue.base};
    box-shadow: 0 0.2rem ${props => props.theme.spacing.custom(11)} 0
      ${props => props.theme.colors.shadow.base};
    cursor: pointer;
  }
`;

export const MetaLandingWrapper = styled.div(
  props => `

  display:flex;
  justify-content: space-between;
  width: ${props.width};
  border-radius:${props.theme.misc.borderRadius.xxxlarge};
  border-bottom-right-radius: ${props.theme.misc.borderRadius.custom(0)};
  border-bottom-left-radius: ${props.theme.misc.borderRadius.custom(0)};
  background-color: ${props.theme.colors.goBrandOrange.base};
  padding:${props.theme.spacing.base};
  position:relative;
  top:${props.theme.spacing.small};
  left:${props.theme.spacing.large};

`,
);

export const MetaLandingText = styled.p(
  props => `
  font-size:${props.theme.font.custom(14)};
  font-weight:bold;
  color: ${props.theme.colors.goWhite.base};
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`,
);

export const MetaWrappedImg = styled(Image)(
  props => `
  display: flex;
  position: relative;
  border-radius: ${props.theme.misc.borderRadius.xxlarge};
  object-fit: cover;
    `,
);

export const HotelCardInfoWrapperDiv = styled.div`
  width: 71%;
  display: flex;
  ${props => (props.isSoldOut ? 'flex-direction: column;' : '')}
`;

// ==================================== HOTEL INFO STYLES START HERE ====================================

export const HotelInfoWrapperDiv = styled.div(
  props => `
  display: flex;
  flex-wrap: wrap;
  width: 65%;
  padding: ${props.theme.spacing.custom(12)} ${props.theme.spacing.custom(
    12,
  )} ${props.theme.spacing.custom(12)} 0;
`,
);

export const PersuasionWrapperDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: flex-end;
`;

export const HeadingInfoWrapperDiv = styled.div`
  width: 100%;
`;

export const HotelTypeTag = styled.span(
  props => `
  color: ${props.theme.colors.downriver.dark};
  padding: ${props.theme.spacing.xsmall};
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  text-transform: uppercase;
  border-radius: ${props.theme.misc.borderRadius.small};
  margin: 0 ${props.theme.spacing.small};
`,
);

export const HotelNameWrapperDiv = styled.div(
  props => `
  width: 30rem;
  padding: ${props.theme.spacing.small} 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`,
);

export const HotelNameSeoAnchor = styled.a(
  props => `
  font-size: ${props.theme.font.large};
  font-family: ${props.theme.font.fontFamily};
  font-weight: bold;
  line-height: 1.3;
  cursor: pointer;
  color: ${props.theme.colors.downriver.base};
`,
);

export const RoomTypeWrapperDiv = styled.div(
  props => `
  display: flex;
  padding: 0.6rem 0 0.6rem 0;
  align-items: center;
`,
);

export const RoomTypeTextWrapper = styled.span(
  props => `
  color: ${props.theme.colors.downriver.dark};
  line-height: 1.3;
  max-width: ${props.maxWidth || '30rem'};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`,
);

export const RoomTypeIconWrapperSpan = styled.span`
  margin-right: 0.8rem;
`;

// =========================== HOTEL INFO STYLES END HERE ===========================

// =========================== HOTEL PRICING STYLES START HERE ===========================

export const HotelPricingInfoWrapperDiv = styled.div(
  props => `
  display: flex;
  flex-direction: column;
  width: 35%;
  justify-content: space-between;
  border-radius: 0 ${props.theme.misc.borderRadius.large} ${props.theme.misc.borderRadius.large} 0;
  border-left: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.light};
  position:relative;
`,
);

export const ContentWrapperDiv = styled.div(
  props => `
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-end;
  padding: ${props.theme.spacing.base} ${props.theme.spacing.large};
`,
);

export const PaxSplitWrapperDiv = styled.div(
  props => `
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin: ${props.theme.spacing.small} 0 ${props.theme.spacing.small} 0;
  border-radius: ${props.theme.misc.borderRadius.small};
`,
);

export const PaxSplitTextWrapper = styled.span`
  text-transform: capitalize;
  font-weight: bold;
`;

// ! ERROR: must move gradient styles also into theme object, here, this cannot support different gradient
// for different level(s)
export const TierLevelWrapperDiv = styled.div(
  props => `
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding: ${props.theme.spacing.xsmall} ${props.theme.spacing.small} ${props.theme.spacing.xsmall}
    ${props.theme.spacing.base};
  background-image: radial-gradient(circle at 2% 16%, #d2bd60, #aa9a55);
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-bottom: ${props.theme.spacing.small};
`,
);

export const TierLevelTextWrapper = styled.span(
  props => `
  color: ${props.theme.colors.goWhite.base};
  font-weight: bold;
  text-transform: uppercase;
  display: inline-flex;
`,
);

export const RupeeSymbolWrapDiv = styled.p(
  props => `
  line-height: 1;
  color: ${props.theme.colors.downriver.medium};
  margin-top: 0.1rem;
`,
);

export const PriceInfoWrapperDiv = styled.div(
  props => `
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin:${props.theme.spacing.base} 0;
  padding: 0 ${props.theme.spacing.large};
`,
);

export const OriginalPriceTextWrapper = styled.p(
  props => `
  text-decoration: line-through;
  color: ${props.theme.colors.downriver.medium};
`,
);

export const CurrentPriceTextWrapper = styled.div(
  props => `
  // font-size: ${props.theme.font.custom(22)};
  // font-weight: bold;
  // padding: ${props.theme.spacing.xsmall} 0 0;
  display: flex;
  align-items:center;
`,
);

export const CurrentPrice = styled.p(
  props => `
  font-family: ${props.theme.font.fontFamily};
  font-size: ${props.theme.font.custom(22)};
  font-weight: bold;
`,
);

export const TaxPriceTextWrapper = styled.span(
  props => `
  font-size: ${props.theme.font.small};
  padding: ${props.theme.spacing.xsmall} 0 0;
  text-transform: uppercase;
`,
);

export const PerRoomNightTextWrapper = styled.span(
  props => `
  padding: ${props.theme.spacing.xsmall} 0 0;
  color: ${props.theme.colors.downriver.medium};
`,
);

export const DistanceText = styled.div(
  props => `
  margin-top: ${props.theme.spacing.xsmall};
  color: ${props.theme.colors.downriver.medium};
  align-items: flex-end;
  line-height: 1.6;
`,
);

export const SignUpTextWrap = styled.span(
  props => `
    cursor: pointer;
    display: inline-flex;
    font-size: ${props.theme.font.custom(11)};
    color: rgba(133, 71, 0, 0.97);
    font-weight:bold;
    margin:0 ${props.theme.spacing.small};
`,
);

export const SignUpPriceWrap = styled.span(
  props => `
    cursor: pointer;
    display: flex;
    align-items:center;
    font-weight:bold;
    font-size: ${props.theme.font.custom(14)};
    color: ${props.theme.colors.downriver.dark};
`,
);

export const SignUpPerNight = styled.span(
  props => `
    cursor: pointer;
    display: inline-flex;
    color: ${props.theme.colors.downriver.dark};
`,
);

export const EMITextWrapperDiv = styled.div(
  props => `
  margin-bottom: ${props.theme.spacing.small};
  align-items: flex-end;
  display:flex;
  color:${props.theme.colors.downriver.base};
  border: .1rem solid ${props.theme.colors.ash.medium};
  padding: ${props.theme.spacing.custom(2)};
  border-radius: ${props.theme.misc.borderRadius.base};
`,
);

export const EMIContainer = styled.div(
  props => `
  margin: ${props.theme.spacing.base} 0 0 0;
`,
);

export const EMIWrap = styled.div(
  props => `
  border-radius: ${props.theme.misc.borderRadius.base};
  background-image: linear-gradient(105deg,#34393a,#adaeb2 100%);
  color:${props.theme.colors.goWhite.base};
  font-weight:bold;
  font-family: ${props.theme.font.fontFamily};
  padding: 0 ${props.theme.spacing.custom(2.9)};
  margin-right: ${props.theme.spacing.custom(3)};

`,
);

export const EMITextPrice = styled.span(
  props => `

  color:${props.theme.colors.downriver.dark};
  font-weight:bold;
  margin-left: ${props.theme.spacing.custom(3)};
`,
);

/*** signup animation on SRP card ***/

export const SignUpLockOuterWrapper = styled.div(
  props => `
    display : flex;
    align-items:center;
    justify-content: flex-end;
    margin-top: 1rem;
    background: ${props.theme.colors.goYellow.light};
    padding:${props.theme.spacing.base};
    width:100%;
    border-bottom-right-radius: ${props.theme.misc.borderRadius.xxxlarge};
    border-top: .2rem solid ${props.theme.colors.goBrandBlue.medium};
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large} ${props.theme.spacing.base} ${props.theme.spacing.base};
    position:relative;
`,
);

export const LockBg = styled.div(
  props => `
    display : flex;
    align-items:center;
    justify-content: flex-end;
    background: ${props.theme.colors.goYellow.light};
    padding:${props.theme.spacing.base};
    width:100%;
    border-bottom-right-radius: ${props.theme.misc.borderRadius.custom(12)};
    border-top: .2rem solid ${props.theme.colors.goBrandBlue.medium};
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large} ${props.theme.spacing.base} ${
    props.theme.spacing.base
  };
    position:relative;
`,
);

/*** signup animation on SRP card ***/

const ShrinkLock = keyframes`

    0%     { transform: translatex(0rem) translatey(0rem) scale(1)}
    100%   { transform: translatex(-10rem) translatey(12rem) scale(0.3);}
`;

const hideBackground = keyframes`
    0% {  opacity: .47; }
    50% {  opacity: .47; }
    100% { visibility: hidden; opacity:0;}
`;

const ShakeLock = keyframes`
    0%   { transform: translateX(0); }
    20%  { transform: translateX(-1.5rem); }
    40%  { transform: translateX(1.5rem); }
    60%  { transform: translateX(-1.5rem); }
    80%  { transform: translateX(1.5rem); }
    100% { transform: translateX(0); }
`;

export const LockBackground = styled.div`
  display: flex;
  position: absolute;
  background: ${props => props.theme.colors.goYellow.light};
  width: 100%;
  height: 100%;
  opacity: 0.47;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${hideBackground} 1.5s 1s;
  animation-fill-mode: forwards;
`;

export const SignUpLockWrapAnimated = styled(SignUpLockIcon)`
  animation-iteration-count: 1;
  animation: ${ShakeLock} 1s 0.3s, ${ShrinkLock} 0.5s 1.3s;
  transform-origin: bottom;
  animation-fill-mode: forwards;
  animation-timing-function: ease-out;
  opacity: 1;
  position: absolute;
  top: 29%;
  right: 30%;
  @media (min-width: 768px) and (max-width: 1024px) {
    right: 24%;
  }
`;

export const SignUpLockWrap = styled(SignUpLockIcon)`
  transform-origin: bottom;
  opacity: 1;
  position: absolute;
  top: 29%;
  right: 30%;
  transform: translatex(-10rem) translatey(12rem) scale(0.3);
`;
// =========================== HOTEL PRICING STYLES END HERe ===========================

export const ItemMoreWrap = styled.span(
  props => `
    position:relative;
      `,
);

export const ItemMoreList = styled.ul(
  props => `
  visibility: hidden;
  background-color: ${props.theme.colors.downriver.base};
  color: ${props.theme.colors.goWhite.base};
  border-radius: ${props.theme.misc.borderRadius.large};
  padding: ${props.theme.spacing.base};
  width:22.7rem;
  z-index:${props.theme.misc.zIndex.xlarge};
  /* Position the tooltip */
  position: absolute;
  right:0rem;
  top:3rem;
  // z-index:1;
  >li{
    padding-bottom:${props.theme.spacing.small};
    &::before{
      content: "• ";
      color:${props.theme.colors.goWhite.base};
      width: 1rem;
    }
  }
  &::after{
    content: "";
    position: absolute;
    top: -1.5rem;
    right: 1.5rem;
    border-width: .8rem;
    border-style: solid;
    border-color: transparent transparent ${props.theme.colors.downriver.base} transparent;
  }
`,
);

export const ItemMoreText = styled.button(
  props => `

  cursor:pointer;
  margin-left:${props.theme.spacing.small};
  border:none;
  &:hover ~ ${ItemMoreList} {
    visibility: visible;
  }
  &:focus{
    box-shadow: none;
    outline-offset: 0;
    outline: 0;
  }
  `,
);

export const BookNowPayLaterText = styled.p(
  props => `
  padding: 0 ${props.theme.spacing.small} 0;
`,
);

export const BookNowPayLaterWrap = styled.div(
  props => `
    display : flex;
    align-items:center;
    justify-content: flex-end;
    margin-top: 1rem;
    background: ${props.theme.colors.goTeal.light};
    padding:0 ${props.theme.spacing.xsmall};
    border-radius: ${props.theme.misc.borderRadius.base};
    width: fit-content;
    height:2.4rem;
`,
);

// =========================== MEMBER PRICING STYLE ===========================

export const RegularPriceTextWrap = styled.p(
  props => `
  display: inline-flex;
  font-size: ${props.theme.font.base};
  // text-decoration: line-through;
  line-height: 1;
  color: ${props.theme.colors.downriver.medium};
`,
);

export const FreeBreakfastTextWrap = styled.div(
  props => `
  display: flex;
  align-items:center;
  font-size: ${props.theme.font.custom(10)};
  color: ${props.theme.colors.goGreen.base};
  margin-top: ${props.theme.spacing.small};
`,
);

export const FreeBreakfastIconWrap = styled(FreeBreakfast)(
  props => `
  width:1.2rem;
  height:1.2rem;
  margin-right: ${props.theme.spacing.small};
  fill: ${props.theme.colors.goGreen.base};
`,
);

export const MemberPriceWrapDiv = styled.div(
  props => `
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  border:.1rem solid ${props.theme.colors.goBrandBlue.light};
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  border-top-right-radius:0;
  padding: ${props.theme.spacing.small};
`,
);

export const MemberPriceTag = styled.div(
  props => `
  border-radius: ${props.theme.misc.borderRadius.xlarge};
  border-bottom-left-radius:0;
  border-bottom-right-radius:0;
  padding: ${props.theme.spacing.small};
  color: ${props.theme.colors.goWhite.base};
  font-size:${props.theme.font.custom(11)};
  font-weight:bold;
  font-family: ${props.theme.font.fontFamily};
  background-image: linear-gradient(282deg, #f87f46, #f4a900);
`,
);
